import styled from 'styled-components/native';

import { GET_LAYOUT_MAX_WIDTH } from '../../constants/layout';
import Banner from '../../elements/Banner';
import { VendorBanner } from '../../types/VendorDetail';

type Props = {
  headerBanner: VendorBanner;
  isFetching: boolean;
};

const HeaderBanner = ({ headerBanner, isFetching }: Props) => {
  return (
    <S.HeaderBannerWrapper>
      <Banner
        sources={{
          1: { uri: headerBanner.sm },
          2: { uri: headerBanner.md },
          3: { uri: headerBanner.lg },
        }}
        bannerStyle={headerBannerStyle}
        isFetching={isFetching}
      />
      {!isFetching && (
        <S.HeaderBannerGradient
          source={require('./assets/img_brand_banner_gradient.png')}
          testID="HeaderBannerGradient"
        />
      )}
    </S.HeaderBannerWrapper>
  );
};

const S = {
  HeaderBannerWrapper: styled.View`
    position: relative;
  `,
  HeaderBannerGradient: styled.Image`
    position: absolute;
    bottom: 0;
    z-index: 99;
    width: 100%;
    height: 100%;
  `,
};

const BANNER_RATIO = 120 / 375;

const headerBannerStyle = {
  height: GET_LAYOUT_MAX_WIDTH() * BANNER_RATIO,
  width: GET_LAYOUT_MAX_WIDTH(),
};

export default HeaderBanner;
